module.exports = __webpack_public_path__ + "static/media/macroeconomics-completed.8f6887ab.svg";